import { render, staticRenderFns } from "./psOrderB.vue?vue&type=template&id=3fc87539&"
import script from "./psOrderB.vue?vue&type=script&lang=js&"
export * from "./psOrderB.vue?vue&type=script&lang=js&"
import style0 from "./psOrderB.vue?vue&type=style&index=0&id=3fc87539&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports